import React from 'react'

const Filter = ({ types, lang, value, handleChange }) => {
  const options = _.map(types, item => {
    const {
      value,
      label: { en, es },
    } = item
    const label = lang === 'en' ? en : es
    return (
      <option value={value} key={value}>
        {label}
      </option>
    )
  })
  return (
    <div className="select-style">
      <select value={value} onChange={handleChange}>
        {options}
      </select>
    </div>
  )
}

export default Filter



// WEBPACK FOOTER //
// ./src/components/Fleet/Filter.js